import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const FilterContainer = styled.div`
  padding: 1.5rem;
  background-color: ${Theme.colors.G_6};
  border-radius: 0.5rem;
  margin-bottom: 1.25rem;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex-shrink: 0;
`;

export const Input = styled.input`
  padding: 0.625rem 0.75rem;
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.25rem;
  font-size: 0.875rem;
  min-width: 12rem;
  
  &[type='date'] {
    min-width: 10rem;
  }
  
  &::placeholder {
    color: ${Theme.colors.G_2};
  }
`;

export const Select = styled.select`
  padding: 0.625rem 0.75rem;
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.25rem;
  font-size: 0.875rem;
  background-color: white;
  min-width: 10rem;
  cursor: pointer;
`;

export const Checkbox = styled.input`
  width: 1.125rem;
  height: 1.125rem;
  cursor: pointer;
  flex-shrink: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-left: auto;
  flex-shrink: 0;
`;

export const Button = styled.button`
  padding: 0.5rem 1rem;
  background-color: ${Theme.colors.B_1};
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;

  &:hover {
    background-color: ${Theme.colors.B_2};
  }

  &:last-child {
    background-color: ${Theme.colors.G_3};
    &:hover {
      background-color: ${Theme.colors.G_2};
    }
  }
`;


